"use client";

import { Button } from "@workspace/ui/components/button";
import { EventNames, SectionTypes, sendEvent, withSectionType } from "@/lib/utils/analytics";

export function BlogReadMore({
  className,
  id,
}: {
  className?: string;
  id?: string;
}) {
  return (
    <Button variant="outline" className={className} asChild>
      <a
        id={id}
        data-testid={id}
        href="https://blog.inito.com"
        target="_blank"
        rel="noreferrer"
        onClick={() =>
          sendEvent(
            EventNames.READ_MORE_CLICKED,
            withSectionType(SectionTypes.BLOG_SECTION),
          )
        }
      >
        Read more
      </a>
    </Button>
  );
}
